import React from "react";
import { MAX_COLUMNS_OF_VARIANT } from "../../helpers/constants";
import { toogleCheckboxCheckClassName } from "../../helpers/shared";
import { ProductVariants } from "../../models/API";
import { ProductItemProps, VariantProductItemProps } from "./model";

export const VariantCoreSelection: React.FC<
  VariantProductItemProps & ProductItemProps
> = (props) => {
  const ProductVariantRow = (variantData: ProductVariants) => {
    // variantData.PropertiesGroups[0] - always first, because data for all items in this array are always the same for all items
    return (
      <div className="row regular">
        <div className="col">
          <span>
            {props.dictionary.FirstColumnText}
            {" - "}
          </span>
          {variantData.VariantName}
        </div>

        {variantData.PropertiesGroups.length > 0 &&
          variantData.PropertiesGroups[0].Properties &&
          variantData.PropertiesGroups[0].Properties.map(
            (propertiesData, index) =>
              index < MAX_COLUMNS_OF_VARIANT && (
                <div
                  className="col"
                  key={`product-variant-column-${variantData.Id}-${propertiesData.NameId}-${index}`}
                >
                  <span>
                    {propertiesData.DisplayName}{" "}
                    {propertiesData.Unit && (
                      <span>({propertiesData.Unit})</span>
                    )}
                    {" - "}
                  </span>
                  {propertiesData.Value}
                </div>
              )
          )}

        <div className="divider"></div>
        <div className="col checkbox inquiry">
          <span>{props.dictionary.InquiryText}</span>
          <i
            className={toogleCheckboxCheckClassName(
              props.dataForInquiry,
              variantData.Id
            )}
            onClick={() => {
              props.selectForInquiry(variantData.Id);
            }}
          ></i>
        </div>
        <div className="col checkbox compare">
          <span>{props.dictionary.CompareText}</span>
          <i
            className={toogleCheckboxCheckClassName(
              props.compareProductsSelected,
              variantData.Id
            )}
            onClick={() => {
              props.selectForComparison(variantData.Id);
            }}
          ></i>
        </div>
      </div>
    );
  };

  const ProductVariantColumnsHeader = () => {
    const firstItem = props.productData.Variants[0]; // always first, becasue in variant "core-selection" array has only one item
    // firstItem.PropertiesGroups[0] - always first, because data for all items in this array are always the same for all items
    return (
      <React.Fragment>
        {firstItem.PropertiesGroups.length > 0 &&
          firstItem.PropertiesGroups[0].Properties.length > 0 &&
          firstItem.PropertiesGroups[0].Properties.map(
            (propertiesData, index) => {
              if (index < MAX_COLUMNS_OF_VARIANT) {
                return (
                  <div
                    className="col"
                    key={`product-variant-column-${props.productData.Id}-${propertiesData.NameId}-${index}`}
                  >
                    {propertiesData.DisplayName}{" "}
                    {propertiesData.Unit && (
                      <span>({propertiesData.Unit})</span>
                    )}
                  </div>
                );
              } else {
                return false;
              }
            }
          )}
      </React.Fragment>
    );
  };

  return (
    <div className="item-list-holder">
      {props.productData.Variants && (
        <React.Fragment>
          <div className="row header">
            <div className="col">{props.dictionary.FirstColumnText}</div>
            <ProductVariantColumnsHeader />
            <div className="divider"></div>
            <div className="col inquiry">{props.dictionary.InquiryText}</div>
            <div className="col compare">{props.dictionary.CompareText}</div>
          </div>
          {props.productData.Variants.map((variantData) => {
            return (
              <ProductVariantRow
                {...variantData}
                key={`product-variant-row-${variantData.Id}`}
              />
            );
          })}
          <div className="row" />
        </React.Fragment>
      )}
    </div>
  );
};
